import React, { forwardRef } from 'react';
import { View } from '../../../../../../components/Common/react-native-components';
import MultiSeriesLineChart from '../../../MultiSeriesLineChart';
import Table from '../../../../../../components/Common/Table';
import {
  buildMonthSeriesForMultiLineChart,
  convertCstDataIntoTableCompatibleTest,
  currentDateFormat,
  DATE_FORMAT_MAPPING,
  seprateDateAndNonDateColumns
} from '../../../../../../utils/transformChartsAndTableData';
import moment from 'moment';
import { CHART_COLORS } from '../../../../constants';
import GenericNoData from '../../../../../../components/Common/NoData/GenricNoData';
import { cloneDeep, get } from 'lodash';

const ScoreOverTime = forwardRef((props, ref) => {
  const { type, itemData, lowSampleSize } = props;

  if (!itemData?.cstData) {
    return <GenericNoData />;
  }

  let item = cloneDeep(itemData?.cstData?.metric_data?.[0])
  item.splice(item.length - 1, 1)
  const metric_count = [[...item], [...item]]

  const tableData = convertCstDataIntoTableCompatibleTest({ ...itemData?.cstData, metric_count } || {});
  const { columns = [], metric_data = [], rows = [] } = itemData?.cstData || {};
  const notAllowedColumns = ['number_of_responses'];

  let multiLineChartData = buildMonthSeriesForMultiLineChart(columns, rows, metric_data, CHART_COLORS);

  let finalData = multiLineChartData?.map((e, index) => {
    const rowData = tableData?.table_rows?.[index];
    return {
      ...e,
      label: {
        value: rowData?.Total,
        label: 'Total Pecentage'
      },
      subLabel: {
        value: rowData?.Benchmark,
        label: 'Same Period Ago'
      }
    };
  })?.filter(e => !notAllowedColumns.includes(e.name))
  console.log(finalData, ";;;;")
  const chartCategories = seprateDateAndNonDateColumns(columns)?.dateFields?.map(e => {
    let dateFormat = currentDateFormat(e);
    return moment(e, dateFormat).format(DATE_FORMAT_MAPPING[dateFormat]);
  });

  function renderContent() {
    switch (type) {
      case 'BAR':
        return (
          <MultiSeriesLineChart
            ref={ref}
            widgetData={itemData}
            categories={chartCategories}
            chartType={'line'}
            data={finalData || []}
          />
        );
      case 'TIME':
        return (
          <MultiSeriesLineChart
            ref={ref}
            widgetData={itemData}
            categories={chartCategories}
            chartType={'column'}
            data={finalData || []}
          />
        );
      case 'TABLE':
        return (
          <View style={{ height: 'auto' }}>
            <Table lowSampleSize={lowSampleSize} table_data={tableData} expendable={false} />
          </View>
        );
    }
  }

  return <View>{renderContent()}</View>;
});

export default ScoreOverTime;
